export const options = [{ label: "UGX", value: "UGX" }]
export const getData = (key = "") => {
  let data = [
    {
      Supplier: "1X2gaming",
      Category: "Virtuals",
      Bets: 3021,
      TotalStake: 2978327.25,
      StakeTax: "0",
      EffectiveStake: 2978327.25,
      Boost: "0",
      WHT: "0",
      Payout: 2653108.53,
      GGR: 325218.72,
      GGRRatio: "10.92%",
      SupplierShare: 39026.25,
      SupplierShareRatio: "12%",
    },
    {
      Supplier: "betradar",
      Category: "Live Sports",
      Bets: 704,
      TotalStake: 10557255,
      StakeTax: "0",
      EffectiveStake: 10557255,
      Boost: "0",
      WHT: "0",
      Payout: 10374290.24,
      GGR: 182964.76,
      GGRRatio: "1.73%",
      SupplierShare: 18296.48,
      SupplierShareRatio: "10%",
    },
    {
      Supplier: "betradar",
      Category: "SportsBetting",
      Bets: 3838,
      TotalStake: 13778330,
      StakeTax: "0",
      EffectiveStake: 13778330,
      Boost: 26522.44,
      WHT: "0",
      Payout: 8622804.22,
      GGR: 5155525.78,
      GGRRatio: "37.42%",
      SupplierShare: 515552.58,
      SupplierShareRatio: "10%",
    },
    {
      Supplier: "GameArt",
      Category: "Casino",
      Bets: 1486,
      TotalStake: 847850,
      StakeTax: "0",
      EffectiveStake: 847850,
      Boost: "0",
      WHT: "0",
      Payout: 776875,
      GGR: 70975,
      GGRRatio: "8.37%",
      SupplierShare: 5678,
      SupplierShareRatio: "8%",
    },
    {
      Supplier: "Pragmatic",
      Category: "Casino",
      Bets: 3470,
      TotalStake: 1975741.71,
      StakeTax: "0",
      EffectiveStake: 1975741.71,
      Boost: "0",
      WHT: "0",
      Payout: 5706126.02,
      GGR: -3730384.31,
      GGRRatio: "-188.81%",
      SupplierShare: -335734.59,
      SupplierShareRatio: "9%",
    },
    {
      Supplier: "Pragmatic",
      Category: "Live Casino",
      Bets: 10,
      TotalStake: 40500,
      StakeTax: "0",
      EffectiveStake: 40500,
      Boost: "0",
      WHT: "0",
      Payout: 34900,
      GGR: 5600,
      GGRRatio: "13.83%",
      SupplierShare: 560,
      SupplierShareRatio: "10%",
    },
    {
      Supplier: "Pragmatic",
      Category: "Scratch Cards",
      Bets: 16,
      TotalStake: 23000,
      StakeTax: "0",
      EffectiveStake: 23000,
      Boost: "0",
      WHT: "0",
      Payout: 21500,
      GGR: 1500,
      GGRRatio: "6.52%",
      SupplierShare: 75,
      SupplierShareRatio: "5%",
    },
    {
      Supplier: "Pragmatic",
      Category: "Table Games",
      Bets: 37,
      TotalStake: 53341.25,
      StakeTax: "0",
      EffectiveStake: 53341.25,
      Boost: "0",
      WHT: "0",
      Payout: 100238.75,
      GGR: -46897.5,
      GGRRatio: "-87.92%",
      SupplierShare: -1406.93,
      SupplierShareRatio: "3%",
    },
    {
      Supplier: "Pragmatic",
      Category: "Virtuals",
      Bets: 175,
      TotalStake: 254400,
      StakeTax: "0",
      EffectiveStake: 254400,
      Boost: "0",
      WHT: "0",
      Payout: 519993.94,
      GGR: -265593.94,
      GGRRatio: "-104.4%",
      SupplierShare: -21247.52,
      SupplierShareRatio: "8%",
    },
  ]

  return data
}
